/* eslint-disable */
import React, { useEffect, useMemo } from 'react';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { useState, Downgraded } from '@hookstate/core';
import { Paper, Box, Backdrop } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import DataList from './dataList/dataList';
import { ScheduleDataService } from '../../services/ScheduleService';
import Helper from '../../utility/helper';
import APIHelper from '../../utility/ApiHelper';
import APIURLConstant from '../../config/config';
import moment from 'moment';
import AddAcctivity from './addActivity';
import UserListDialog from './userListDialog';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import ActivityListDialog from './activityListDialog';
import { excelFileType, ScheduleUserType } from '../../constants/Constant';
import { FULL_PERMISSION, VIEW_PERMISSION } from '../../constants/Constant';
import { saveAs } from 'file-saver';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
import './pdfReport.css';
//import PreviewReport from './previewReport';
// import { PDFDownloadLink } from '@react-pdf/renderer';
// import PDFContainer from './pdfContainer';
import PDFDownload from './pdfDownload';
import AddSubAcctivity from './addSubActivity';
import { useThemeState } from '../../hookState/ThemeState';
import AzureConstant from '../../config/authConfigConstant';
// import axios from 'axios';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    cardContent: {
        '&:last-child': {
            paddingBottom: '16px',
        },
    },
}));

function ActivityList(props) {
    const classes = useStyles();
    const loading = useState(true);
    const originalData = useState([]);
    const activityList = useState([]);
    const eventData = useState({});
    const openDialog = useState(false);
    const openSubActivityDialog = useState(false);
    const userInfo = useState({});
    const openAddParticipantDialog = useState(false);
    //const dates = useState([]);
    const activityInfo = useState(null);
    const subActivityInfo = useState(null);
    const overallParticipants = useState([]);
    const filteredParticipants = useState([]);
    const currentActivity = useState({});
    const isView = useState(false);
    const [search, setSearch] = React.useState('');
    const allActivityListData = useState([]);
    const userId = useState(0);
    const selectedUser = useState(0);
    const activeUserId = useState(0);
    const selectedScheduleReport = useState([]);
    const selectedIds = useState([]);
    const openActivityDialog = useState(false);
    const themeState = useThemeState();
    const [showTabUser, setShowTabUser] = React.useState([]);
    const [publishLoader, setPublishLoader] = React.useState(false)
    const [unpublishLoader, setUnublishLoader] = React.useState(false)
    const [individualScheudleEmailLoader, setIndividualScheudleEmailLoader] = React.useState(false)
    const [uploadActivityLoader, setUploadActivityLoader] = React.useState(false)
    const [publishlistdata, setpublishlistdata] = React.useState([
        {
            key: '1',
            value: 'All'
        },
        {
            key: '2',
            value: 'Published',
        },
        {
            key: '3',
            value: 'UnPublished',
        }
    ]);
    const [publishlistvalue, setpublishlistvalue] = React.useState('All');
    const [publishData, setpublishData] = React.useState([]);
    const [unpublishData, setunpublishData] = React.useState([]);
    const [allpublishData, setallpublishData] = React.useState([]);

    // const [pdfActivityData, setPdfActivityData] = React.useState([]);

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: props.data[0] !== undefined ? 5000 : 20,
        noOfPages: null,
    });
    const [staffToggleChecked, setStaffToggleChecked] = React.useState(true);
    const [userActivityPDFLoader, setUserActivityPDFLoader] =
        React.useState(false);
    const [userActivityExcelLoader, setUserActivityExcelLoader] =
        React.useState(false);

    const [openBackdrop, setBackDrop] = React.useState(false);
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const deleteSubActivityConfirmation = useState({
        open: false,
        title: '',
        message: '',
        ids: '',
    });
    const sendEmailConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const unPublishConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const publishConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const publishSelectedConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const unPublishSelectedConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    const [modPermission, setModPermission] = React.useState(null);
    const [selectAllFlag, setSelectAllFlag] = React.useState(false);
    const [showPrimaryColorPicker, setShowPrimaryColorPicker] =
        React.useState(false);
    const [primaryColor, setPrimaryColor] = React.useState(
        themeState.primary.value
    );
    const [submitPublishUnpublished, setSubmitPublishUnpublished] =
        React.useState(false);
    const [showForAdminOnly, setShowForAdminOnly] = React.useState(false);
    const [selectUnPublished, setSelectUnPublished] = React.useState(false);
    const [filterDates, setFilterDates] = React.useState([]);
    const [gridFilters, setGridFilters] = React.useState({
        search: '',
        date: [],
        filterByPublishUnPublish: ''
    });

    useEffect(() => {
        const guserInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        userInfo.set(guserInfo);
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.get().eventID != eventInfo.eventID)
        ) {
            eventData.set(eventInfo);
        }

        if (Helper.isAdminUser(guserInfo) || Helper.isEventAdmin(guserInfo)) {
            props.data &&
                props.data.length > 0 &&
                props.data[0].tab === 'userActivity'
                ? setShowForAdminOnly(false)
                : setShowForAdminOnly(true);
            setModPermission(FULL_PERMISSION);
        } else {
            setShowForAdminOnly(false);
            setModPermission(VIEW_PERMISSION);
        }
        APIHelper.get(
            APIURLConstant.GET_ADMIN_EVENT_PARTICIPANTS(eventInfo.eventID)
        ).then((res) => {
            let participantData = [];
            res.data.rows.map((item) => {
                if (
                    item.roleName !== ScheduleUserType[1] &&
                    item.roleName !== 'Event Admin'
                ) {
                    participantData.push({ ...item, selected: false });
                }
            });
            overallParticipants.set(participantData);
            let userId = 0;
            if (
                Helper.isAdminUser(guserInfo) ||
                Helper.isEventAdmin(guserInfo)
            ) {
                fetchActivities(userId);
            } else if (guserInfo.roles && Helper.isEventStaff(guserInfo)) {
                props.data &&
                    props.data.length > 0 &&
                    props.data[0].tab === 'userActivity'
                    ? fetchActivities(userId)
                    : fetchActivities(userInfo.attach(Downgraded).get().userID);
            } else {
                fetchActivities(userId);
            }
            //overallPerticipants.set(data.filter(x => !excludeRoleName.includes(x.roleName)));
        });
    }, []);

    // function getDates(startDate, endDate) {
    //     const dates = []
    //     let currentDate = startDate
    //     const addDays = function (days) {
    //         const date = new Date(this.valueOf())
    //         date.setDate(date.getDate() + days)
    //         return date
    //     }
    //     while (currentDate <= endDate) {
    //         dates.push(moment(currentDate).format('MM/DD/YYYY'))
    //         currentDate = addDays.call(currentDate, 1)
    //     }
    //     return dates
    // }

    useEffect(() => {
        if (originalData.get() && originalData.get().length > 0) {
            let list = originalData.attach(Downgraded).get();
            getFormatedData(list, search, gridFilters);
        }

    }, [gridFilters])


    const handleOnChange = (event) => {
        let str = event.target.value;
        let value = str.replace(/^\s+/g, '');
        //let list = originalData.attach(Downgraded).get();
        setSearch(value);
        setGridFilters({
            ...gridFilters,
            search: value
        });
        //getFormatedData(list, value, gridFilters);
    };
    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getFormatedData(originalData.attach(Downgraded).get(), search);
    };
    const getFormatedData = (data, search, gridFilters) => {
        const eventInfo = Helper.getStorage('eventInfo');
        let activityData = [];
        let allActivityData = [];
        let activityDataUnpublish = [];
        //let activityDates = [];
        const indexOfLastRecord =
            pagingInfo.get().currentPage * pagingInfo.get().itemsPerPage;
        const indexOfFirstRecord =
            indexOfLastRecord - pagingInfo.get().itemsPerPage;

        originalData
            .attach(Downgraded)
            .get()
            .map((item) => {
                let count = 0;
                if (item.participants && item.participants.length > 0) {
                    var newParticipantArray = item.participants.filter(
                        function (obj) {
                            return overallParticipants
                                .attach(Downgraded)
                                .get()
                                .some(function (obj2) {
                                    return obj.userID == obj2.userID;
                                });
                        }
                    );
                    if (newParticipantArray.length > 0) {
                        count = newParticipantArray.length;
                    }
                }
                allActivityData.push({
                    actualData: item,
                    row: [
                        {
                            label: 'checkbox',
                            key: 'activityID',
                            activityID: item.activityID,
                            width: '0.05',
                        },
                        {
                            label: 'Start Time',
                            key: 'startTime',
                            startTime:
                                item.startDateTime !== null
                                    ? moment(item.startDateTime).format(
                                        'hh:mm A'
                                    )
                                    : '',
                            width: '0.2',
                            inColumn: true,
                        },

                        {
                            label: 'End Time',
                            key: 'endTime',
                            endTime:
                                item.endDateTime !== null
                                    ? moment(item.endDateTime).format('hh:mm A')
                                    : '',
                            width: '0.2',
                            inColumn: true,
                        },
                        {
                            label: 'Name',
                            key: 'activityName',
                            activityName: item.activityName,
                            showLabel: false,
                            width: '0.2',
                            inColumn: true,
                            notes: item.notes,
                            showNote: true,
                        },
                        {
                            label: 'Location',
                            key: 'location',
                            location: item.location,
                            width: '0.12',
                            inColumn: true,
                            alignRight: true,
                        },
                        {
                            label: 'Tags',
                            key: 'activityTags',
                            activityTags:
                                item.activityTags && item.activityTags !== null
                                    ? item.activityTags
                                        .map((x) => x.tagName)
                                        .join(', ')
                                    : [],
                            showChips: true,
                            width: '0.1',
                            showLabel: false,
                        },
                        {
                            label: 'Attire',
                            key: 'attire',
                            attire: item.attire,
                            width: '0.1',
                            inColumn: true,
                            alignRight: true,
                        },
                        {
                            label: 'ScheduleParticipant',
                            key: 'ShowStaff',
                            // showChips: true,
                            width: '0.01',
                            // showLabel: false,
                        },
                        {
                            label: 'isPublished',
                            key: 'isPublished',
                            isPublished: eventInfo.isPublished,
                            width: '0.02',
                            inColumn: true,
                        },
                        {
                            label: 'Action',
                            key: 'showRowPublish',
                            showRowPublish: 'showRowPublish',
                            isRowPublished: item.isRowPublished,
                            width: '0.02',
                            inColumn: true,
                        },
                        {
                            label: 'Action',
                            key: 'addParticipants',
                            addParticipants: 'Add Participants',
                            width: '0.02',
                            inColumn: true,
                        },
                        {
                            label: 'Action',
                            key: 'participants',
                            participants: 'Participants',
                            count: count,
                            width: '0.02',
                            inColumn: true,
                        },
                        {
                            label: 'Action',
                            key: 'edit',
                            edit: 'Edit',
                            width: '0.02',
                            inColumn: true,
                        },
                        {
                            label: 'Action',
                            key: 'delete',
                            delete: 'Delete',
                            width: '0.02',
                            inColumn: true,
                        },
                        // {
                        //     label: 'Action',
                        //     key: 'addSubActivity',
                        //     addSubActivity: 'Add SubActivity',
                        //     width: '0.02',
                        //     inColumn: true,
                        // },
                        {
                            label: 'Published',
                            key: 'publish',
                            publish: item.isRowPublished === true ? 'T' : 'F',
                            width: '0.08',
                            inColumn: true,
                            alignCenter: true,
                        },
                    ],
                    selected: false,
                });
            });
        allActivityListData.set(allActivityData);
        // setallpublishData(allActivityListData.get());
        // const publishedActivities = allActivityData.filter(
        //     (item) => item.actualData.isRowPublished === true
        // );
        // const unpublishedActivities = allActivityData.filter(
        //     (item) => item.actualData.isRowPublished !== true
        // );
        // setpublishData(publishedActivities);
        // setunpublishData(unpublishedActivities);
        if (data && data !== undefined && data.length > 0) {
            data.map((item) => {
                // console.log("item.participants", item.participants);
                // let startDate = item.startDateTime !== null ? moment(item.startDateTime).format('MM/DD/YYYY') : null;
                // let endDate = item.endDateTime !== null ? moment(item.endDateTime).format('MM/DD/YYYY') : null;
                // let range = [];
                // if (startDate !== null && endDate !== null) {
                //     range = getDates(moment(startDate), moment(endDate))
                // } else if (startDate !== null && endDate === null) {
                //     range = [startDate];
                // } else if (startDate === null && endDate !== null) {
                //     range = [endDate];
                // } else {
                //     range = ['TBD']
                // }
                let count = 0;

                if (item.participants && item.participants.length > 0) {
                    var newParticipantArray = item.participants.filter(
                        function (obj) {
                            return overallParticipants
                                .attach(Downgraded)
                                .get()
                                .some(function (obj2) {
                                    return obj.userID == obj2.userID;
                                });
                        }
                    );
                    if (newParticipantArray.length > 0) {
                        count = newParticipantArray.length;
                    }
                }
                var onlyStartTime = item.startDateTime && item.startDateTime.substring(item.startDateTime.length - 8);
                var onlyEndTime = item.endDateTime && item.endDateTime.substring(item.endDateTime.length - 8);
                // console.log("onlyStartTime",onlyStartTime, "onlyEndTime",onlyEndTime);
                //activityDates = [...activityDates, ...range]
                if (
                    props &&
                    props.data &&
                    props.data.length > 0 &&
                    props.data[0].tab === 'userActivity'
                ) {
                    if (item.isRowPublished === true) {
                        activityData.push({
                            actualData: item,
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'activityID',
                                    activityID: item.activityID,
                                    width: '0.05',
                                },
                                {
                                    label: 'Start Time',
                                    key: (onlyStartTime === "00:00:00" || onlyStartTime == null) ? "" : 'startTime',
                                    startTime: moment(
                                        item.startDateTime
                                    ).format('hh:mm A'),
                                    width: '0.1',
                                    inColumn: true,
                                },

                                {
                                    label: 'End Time',
                                    key: (onlyEndTime === "00:00:00" || onlyEndTime == null) ? "" : 'endTime',
                                    endTime: moment(item.endDateTime).format(
                                        'hh:mm A'
                                    ),
                                    width: '0.1',
                                    inColumn: true,
                                },
                                {
                                    label: 'Name',
                                    key: 'activityName',
                                    activityName: item.activityName,
                                    showLabel: false,
                                    width: '0.2',
                                    inColumn: true,
                                    notes: item.notes,
                                    showNote: true,
                                },
                                {
                                    label: 'Tags',
                                    key: 'activityTags',
                                    activityTags:
                                        item.activityTags !== null &&
                                            item.activityTags !== undefined
                                            ? item.activityTags
                                                .map((x) => x.tagName)
                                                .join(', ')
                                            : [],
                                    showChips: true,
                                    width: '0.1',
                                    showLabel: false,
                                },
                                {
                                    label: 'Attire',
                                    key: 'attire',
                                    attire: item.attire,
                                    width: '0.2',
                                    inColumn: true,
                                    // alignRight: true,
                                },
                                {
                                    label: '',
                                    key: 'empty',
                                    empty: '',
                                    width: '0.02',
                                },
                                {
                                    label: 'Location',
                                    key: 'location',
                                    location: item.location,
                                    width: '0.15',
                                    inColumn: true,
                                    // alignRight: true,
                                },
                                // {
                                //     label: 'ScheduleParticipant',
                                //     key: 'ShowStaff',
                                //     // showChips: true,
                                //     width: '0.2',
                                //     // showLabel: false,
                                // },

                                {
                                    label: 'Published',
                                    key: 'publish',
                                    publish: 'T',
                                    width: '0.08',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                            ],
                            selected: false,

                        });
                    } else {
                        activityDataUnpublish.push({
                            actualData: item,
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'activityID',
                                    activityID: item.activityID,
                                    width: '0.05',
                                },
                                {
                                    label: 'Start Time',
                                    key: onlyStartTime === "00:00:00" ? "" : 'startTime',
                                    startTime: moment(item.startTime).format(
                                        'hh:mm A'
                                    ),
                                    width: '0.1',
                                    inColumn: true,
                                },

                                {
                                    label: 'End Time',
                                    key: (onlyEndTime === "00:00:00" || onlyEndTime == null) ? "" : 'endTime',
                                    endTime: moment(item.endTime).format(
                                        'hh:mm A'
                                    ),
                                    width: '0.1',
                                    inColumn: true,
                                },
                                {
                                    label: 'Name',
                                    key: 'activityName',
                                    activityName: item.activityName,
                                    showLabel: false,
                                    width: '0.2',
                                    inColumn: true,
                                    notes: item.notes,
                                    showNote: true,
                                },
                                {
                                    label: 'Tags',
                                    key: 'activityTags',
                                    activityTags:
                                        item.activityTags !== null
                                            ? item.activityTags
                                                .map((x) => x.tagName)
                                                .join(', ')
                                            : [],
                                    showChips: true,
                                    width: '0.1',
                                    showLabel: false,
                                },
                                {
                                    label: 'Attire',
                                    key: 'attire',
                                    attire: item.attire,
                                    width: '0.2 ',
                                    inColumn: true,
                                    // alignRight: true,
                                },
                                {
                                    label: '',
                                    key: 'empty',
                                    empty: '',
                                    width: '0.02',
                                },
                                {
                                    label: 'Location',
                                    key: 'location',
                                    location: item.location,
                                    width: '0.15',
                                    inColumn: true,
                                    // alignRight: true,
                                },
                                // {
                                //     label: 'ScheduleParticipant',
                                //     key: 'ShowStaff',
                                //     // showChips: true,
                                //     width: '0.2',
                                //     // showLabel: false,
                                // },

                                {
                                    label: 'Published',
                                    key: 'publish',
                                    publish: 'F',
                                    inColumn: true,
                                    width: '0.08',
                                    alignCenter: true,
                                },
                            ],
                            selected: false,
                        });
                    }
                } else {

                    activityData.push({
                        actualData: item,
                        row: [
                            {
                                label: 'checkbox',
                                key: 'activityID',
                                activityID: item.activityID,
                                width: '0.05',
                            },
                            {
                                label: 'Start Time',
                                key: onlyStartTime === "00:00:00" ? "" : 'startTime',
                                startTime: moment(item.startDateTime).format(
                                    'hh:mm A'
                                ),
                                width: '0.1',
                                inColumn: true,
                            },

                            {
                                label: 'End Time',
                                key: (onlyEndTime === "00:00:00" || onlyEndTime == null) ? "" : 'endTime',
                                endTime: moment(item.endDateTime).format(
                                    'hh:mm A'
                                ),
                                width: '0.1',
                                inColumn: true,
                            },
                            {
                                label: 'Name',
                                key: 'activityName',
                                activityName: item.activityName,
                                showLabel: false,
                                width: '0.15',
                                inColumn: true,
                                notes: item.notes,
                                showNote: true,
                            },
                            {
                                label: 'Attire',
                                key: 'attire',
                                attire: item.attire,
                                width: '0.1',
                                inColumn: true,
                                // alignRight: true,
                            },
                            {
                                label: 'Location',
                                key: 'location',
                                location: item.location,
                                width: '0.15',
                                inColumn: true,
                                // alignRight: true,
                            },
                            {
                                label: 'Tags',
                                key: 'activityTags',
                                activityTags:
                                    item.activityTags &&
                                        item.activityTags !== null
                                        ? item.activityTags
                                            .map((x) => x.tagName)
                                            .join(', ')
                                        : [],
                                showChips: true,
                                width: '0.1',
                                showLabel: false,
                            },
                            {
                                label: 'ScheduleParticipant',
                                key: 'ShowStaff',
                                // showChips: true,
                                width: '0.15',
                                // showLabel: false,
                            },
                            {
                                label: 'isPublished',
                                key: 'isPublished',
                                isPublished: eventInfo.isPublished,
                                width: '0.02',
                                inColumn: true,
                            },
                            {
                                label: 'Action',
                                key: 'showRowPublish',
                                showRowPublish: 'showRowPublish',
                                isRowPublished: item.isRowPublished,
                                width: '0.02',
                                inColumn: true,
                            },
                            {
                                label: 'Action',
                                key: 'addParticipants',
                                addParticipants: 'Add Participants',
                                width: '0.02',
                                inColumn: true,
                            },
                            {
                                label: 'Action',
                                key: 'participants',
                                participants: 'Participants',
                                count: count,
                                width: '0.02',
                                inColumn: true,
                            },
                            {
                                label: 'Action',
                                key: 'edit',
                                edit: 'Edit',
                                width: '0.02',
                                inColumn: true,
                            },
                            // {
                            //     label: 'Action',
                            //     key: 'delete',
                            //     delete: 'Delete',
                            //     width: '0.02',
                            //     inColumn: true,
                            // },
                            // {
                            //     label: 'Action',
                            //     key: 'addSubActivity',
                            //     addSubActivity: 'Add SubActivity',
                            //     width: '0.02',
                            //     inColumn: true,
                            // },
                        ],
                        selected: false,
                    });
                }
            });
        } else {
            activityData = [];
            //activityDates = []
        }
        activityData = activityData.concat(activityDataUnpublish);
        // setallpublishData(activityData);
        // const publishedActivitiesaall = activityData.filter(
        //     (item) => item.actualData.isRowPublished === true
        // );
        // const unpublishedActivitiesall = activityData.filter(
        //     (item) => item.actualData.isRowPublished !== true
        // );
        // setpublishData(publishedActivitiesaall);
        // setunpublishData(unpublishedActivitiesall);
        // console.log("activityData",activityData);
        // activityData.filter((activity) => {
        //     delete activity.actualData.attire
        // })
        // console.log("activityData1",activityData);

        let modifyList = [];
        if (gridFilters.search || gridFilters.date.length > 0 || gridFilters.filterByPublishUnPublish) {
            allActivityListData
                .attach(Downgraded)
                .get()
                .forEach((item) => {
                    let includeDate = item.actualData.startDateTime && gridFilters.date.length > 0 ? gridFilters.date.includes(moment(item.actualData.startDateTime).format('MM/DD/YYYY')) : true;
                    let val = gridFilters.filterByPublishUnPublish === 'Published' ? true : false;
                    let publishUnPublishFilter = gridFilters.filterByPublishUnPublish ? item.actualData.isRowPublished === val : true;
                    if (includeDate && publishUnPublishFilter) {
                        item.row.forEach((field, j) => {
                            if (
                                typeof item.row[j][item.row[j]['key']] ===
                                'string' &&
                                item.row[j][item.row[j]['key']]
                                    .toLowerCase()
                                    .indexOf(search.toLowerCase()) > -1
                            ) {
                                if (modifyList.indexOf(item) == -1)
                                    modifyList.push(item);
                            }
                        });
                    }

                    if (item.actualData.subActivities !== null) {
                        item.actualData.subActivities.forEach((sub) => {
                            let includeDate = sub.startDateTime && gridFilters.date.length > 0 ? gridFilters.date.includes(moment(sub.startDateTime).format('MM/DD/YYYY')) : true;
                            let val = gridFilters.filterByPublishUnPublish === 'Published' ? 1 : 0;
                            let publishUnPublishFilter = gridFilters.filterByPublishUnPublish ? parseInt(sub.isRowPublished) === parseInt(val) : true;
                            if (includeDate && publishUnPublishFilter &&
                                typeof sub.subActivityName === 'string' &&
                                sub.subActivityName
                                    .toLowerCase()
                                    .indexOf(search.toLowerCase()) > -1
                            ) {
                                if (modifyList.indexOf(item) == -1)
                                    modifyList.push(item);
                            }
                        });
                    }
                });
        } else {
            modifyList = activityData;
        }
        loading.set(false);
        // if (pagingInfo.get().noOfPages == null) {
        //     pagingInfo.set({
        //         ...pagingInfo,
        //         currentPage: pagingInfo.get().currentPage,
        //         itemsPerPage: pagingInfo.get().itemsPerPage,
        //         noOfPages: Math.ceil(
        //             data.length / pagingInfo.get().itemsPerPage
        //         ),
        //     });
        // }
        //console.log('modifyList', modifyList);
        showTabUsers(modifyList);
        activityList.set(modifyList);
        // setallpublishData(modifyList);
        // const publishedActivitiesmodified = modifyList.filter(
        //     (item) => item.actualData.isRowPublished === true
        // );
        // const unpublishedActivitiesmodified = modifyList.filter(
        //     (item) => item.actualData.isRowPublished !== true
        // );
        // setpublishData(publishedActivitiesmodified);
        // setunpublishData(unpublishedActivitiesmodified);
    };
    const showTabUsers = (userList) => {
        let participantsList = [];
        let userIds = [];
        let subActPartiIds = [];
        let getAllUserIds = [];
        userList.forEach((element) => {
            if (element.actualData.userType !== ScheduleUserType[1]) {
                if (element.actualData.isStaffing) {
                    getAllUserIds.push(element.actualData.activityID);
                }
                let ids = element.actualData.participants.map((x) => x.userID);
                element.actualData.subActivities &&
                    element.actualData.subActivities.length > 0 &&
                    element.actualData.subActivities.map((x) => {
                        if (x.isStaffing) {
                            getAllUserIds.push(x.activityID);
                        }
                        x.subActivityParticipants &&
                            x.subActivityParticipants.length > 0 &&
                            x.subActivityParticipants.map((y) =>
                                subActPartiIds.push(y.userID)
                            );
                    });
                userIds = userIds.concat(ids);
            }
        });
        const newMergedArr = userIds.concat(subActPartiIds);

        userIds = [...new Set(newMergedArr)];
        participantsList = overallParticipants
            .attach(Downgraded)
            .get()
            .filter((x) => userIds.includes(x.userID));
        setShowTabUser(participantsList);
    };
    const fetchActivities = async (userId) => {
        // const eventInfo = Helper.getStorage('eventInfo');
        // if ((eventData.get() == null || (
        //     eventData.get() && eventData.eventID.value != eventInfo.eventID
        // ))) {
        //     eventData.set(eventInfo);
        // }
        const userInfo = Helper.getStorage('userInfo');

        let result = await ScheduleDataService.getActivityList(
            eventData.get().eventID,
            userId,
            props.data &&
                props.data.length > 0 &&
                props.data[0].tab === 'userActivity' ? true : false
        );
        let newData = [];
        let scheduleData = [];
        result.data.length > 0 && result.data.map((item) => {
            if (item.userType !== ScheduleUserType[1]) {
                scheduleData.push({ ...item });
            }
        });
        if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) {
            originalData.set(scheduleData);
            newData.push(scheduleData);
        } else if (userInfo.roles && Helper.isEventStaff(userInfo)) {
            // props.data &&
            //     props.data.length > 0 &&
            //     props.data[0].tab === 'userActivity'
            //     ? fetchActivities(userId)
            //     : fetchActivities(userInfo.attach(Downgraded).get().userID)
            if (
                props.data &&
                props.data.length > 0 &&
                props.data[0].tab === 'userActivity'
            ) {
                originalData.set(scheduleData);
                newData.push(scheduleData);
            } else {
                result.data &&
                    result.data.length > 0 &&
                    result.data.map((item) => {
                        if (item.userType === ScheduleUserType[1]) {
                            if (item.isRowPublished === true) {
                                newData.push({ ...item });
                            }
                            // if (item.isRowPublished === true) {
                            //     if (item.isStaffing) {
                            //         newData.push({ ...item })
                            //     } else if (item.participants || item.subActivities) {
                            //         let newObjs = [];
                            //         item.subActivities && item.subActivities.length > 0 && item.subActivities.map((subAct) => {
                            //             if(subAct.isStaffing){
                            //                 newObjs.push({ ...item, subActivities: [subAct]})
                            //             }
                            //         })
                            //         newData.push( newObjs[0] )
                            //     }
                            // }
                            // }
                            //  else {
                            //     console.log("item.participants",item.participants, "else checked");
                            //     item.participants && item.participants.map((val) => {
                            //         if (val.userID === userInfo.userID && item.isRowPublished === true) {
                            //             newData.push({ ...item })
                            //         }
                            //     })
                            // }
                        }
                    });
                const results = newData.filter((element) => {
                    return element !== undefined;
                });
                originalData.set(results);
            }
        } else {
            originalData.set(scheduleData);
            newData.push(scheduleData);
        }
        getDistinctDates(originalData.attach(Downgraded).get());
        getFormatedData(originalData.attach(Downgraded).get(), search, gridFilters);
    };

    const getDistinctDates = (data) => {
        let activityDates = [];
        data.map((item) => {
            let startDate =
                item.startDateTime !== null
                    ? moment(item.startDateTime).format('MM/DD/YYYY')
                    : null;
            let endDate = null; //item.actualData.endDateTime !== null ? moment(item.actualData.endDateTime).format('MM/DD/YYYY') : null;
            let range = [];
            if (startDate !== null && endDate !== null) {
                range = getDates(moment(startDate), moment(endDate));
            } else if (startDate !== null && endDate === null) {
                range = [startDate];
            } else if (startDate === null && endDate !== null) {
                range = [endDate];
            } else {
                range = ['TBD'];
            }
            //let range = getDates(moment(startDate), moment(endDate))

            activityDates = [...activityDates, ...range];
        });
        let uniqueDates = [...new Set(activityDates)];
        let TBDindex = uniqueDates.indexOf('TBD');
        if (TBDindex > -1) {
            uniqueDates.splice(TBDindex, 1);
            uniqueDates = uniqueDates.sort((a, b) => moment(a) - moment(b));
            uniqueDates.unshift('TBD');
        } else {
            uniqueDates = uniqueDates.sort((a, b) => moment(a, "MM/DD/YYYY") - moment(b, "MM/DD/YYYY"));
        }
        // console.log('uniqueDates', uniqueDates);
        // uniqueDates.unshift('');
        setFilterDates(uniqueDates);
    };

    const redirectToCreate = (user) => {
        selectedUser.set(user);
        openDialog.set(true);
        activityInfo.set(null);
    };
    const handleClose = () => {
        openDialog.set(false);
    };
    const handleSubActivityClose = () => {
        openSubActivityDialog.set(false);
    };
    const editActivity = (info) => {
        openDialog.set(true);
        activityInfo.set(info.actualData);
    };
    const editSubActivityRow = (items) => {
        openSubActivityDialog.set(true);
        subActivityInfo.set(items);
    };
    const deleteSubActivityRow = (items) => {
        deleteSubActivityConfirmation.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: 'Do you want to delete Sub Activity?',
            ids: {
                subActivityID: items.subActivityID,
                activityID: items.activityID,
            },
        });
    };
    const handleSubActivityConfirmation = () => {
        let eventInfo = Helper.getStorage('eventInfo');

        let payLoad = {
            eventID: eventInfo.eventID,
            activityID: deleteSubActivityConfirmation.attach(Downgraded).get()
                .ids.activityID,
            modifiedBy: userInfo.attach(Downgraded).get().userID,
            ids: [
                deleteSubActivityConfirmation.attach(Downgraded).get().ids
                    .subActivityID,
            ],
        };
        ApiHelper.post(APIURLConstants.DELETE_SUB_ACTIVITY_LIST, payLoad)
            .then((res) => {
                if (res.data > 0) {
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'User Sub activity deleted successfully',
                    });
                    fetchActivities(userId.get());
                    deleteSubActivityConfirmation.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                        ids: '',
                    });
                }
            })
            .catch((error) => {
                console.log('error : ', error);
                deleteSubActivityConfirmation.set({
                    open: false,
                    title: '',
                    OkButtonText: 'Ok',
                    message: '',
                    ids: '',
                });
            });
    };
    const handleAddParticipants = (activity) => {
        currentActivity.set(activity);
        ScheduleDataService.getActivityParticipants(
            activity.actualData.activityID
        )
            .then((participants) => {
                let ids = participants.map((x) => x.userID);
                let allParticipants = overallParticipants
                    .attach(Downgraded)
                    .get();
                let userList = allParticipants.filter(
                    (x) => !ids.includes(x.userID)
                );
                filteredParticipants.set(userList);
                openAddParticipantDialog.set(true);
            })
            .catch((err) => {
                console.log(err);
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Something went wrong.',
                });
            });
    };
    const handleAddSubActivity = (activity) => {
        subActivityInfo.set({
            activityID: activity.actualData.activityID,
            activityName: activity.actualData.activityName,
        });
        openSubActivityDialog.set(true);
    };

    const handleCloseAddParticipant = () => {
        openAddParticipantDialog.set(false);
        isView.set(false);
    };

    const addParticipants = (selectedUsers) => {
        if (selectedUsers.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else {
            let activity = currentActivity.attach(Downgraded).get();
            let obj = {
                activityID: activity.actualData.activityID,
                createdBy: userInfo.attach(Downgraded).get().userID,
                participants: selectedUsers,
            };
            ScheduleDataService.saveActivityParticipants(obj)
                .then((res) => {
                    if (res) {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'success',
                            message: 'Participants added successfully.',
                        });
                        fetchActivities(userId.get());
                        openAddParticipantDialog.set(false);
                    } else {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Something went wrong.',
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);

                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'Something went wrong.',
                    });
                });
        }
    };

    const handleViewParticipants = (activity) => {
        currentActivity.set(activity);
        isView.set(true);
        ScheduleDataService.getActivityParticipants(
            activity.actualData.activityID
        )
            .then((participants) => {
                let ids = participants.map((x) => x.userID);
                let allParticipants = overallParticipants
                    .attach(Downgraded)
                    .get();
                let userList = allParticipants.filter((x) =>
                    ids.includes(x.userID)
                );
                filteredParticipants.set(userList);
                openAddParticipantDialog.set(true);
            })
            .catch((err) => {
                console.log(err);
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Something went wrong.',
                });
            });
    };

    const deleteParticipants = (selectedUsers) => {
        if (selectedUsers.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else {
            let activity = currentActivity.attach(Downgraded).get();
            let obj = {
                eventID: eventData.get().eventID,
                activityID: activity.actualData.activityID,
                modifiedBy: userInfo.attach(Downgraded).get().userID,
                Ids: selectedUsers,
            };
            ScheduleDataService.deleteActivityParticipants(obj)
                .then((res) => {
                    if (res) {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'success',
                            message: 'Participants deleted successfully.',
                        });
                        fetchActivities(userId.get());
                        openAddParticipantDialog.set(false);
                        isView.set(false);
                    } else {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Something went wrong.',
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);

                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'Something went wrong.',
                    });
                });
        }
    };
    const deleteActivityList = () => {
        const selected = activityList
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Activity first',
            });
        } else {
            let message =
                selected.length == activityList.get().length
                    ? 'Do you want to delete all Activity Lists ?'
                    : 'Do you want to delete selected Activity List ?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const handleActiveUserId = (id) => {
        activeUserId.set(id);
        let allActivities = activityList.get().map((activity) => {
            activity.selected = false;
            return activity;
        });
        activityList.set(allActivities);
    };
    function getDates(startDate, endDate) {
        const dates = [];
        let currentDate = startDate;
        const addDays = function (days) {
            const date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        };
        while (currentDate <= endDate) {
            dates.push(moment(currentDate).format('MM/DD/YYYY'));
            currentDate = addDays.call(currentDate, 1);
        }
        return dates;
    }
    const generateUserActivityExcelReport = (result, userName) => {
        let activityDates = [];
        result.map((item) => {
            let startDate =
                item.actualData.startDateTime !== null
                    ? moment(item.actualData.startDateTime).format('MM/DD/YYYY')
                    : null;
            let endDate = null; // item.actualData.endDateTime !== null ? moment(item.actualData.endDateTime).format('MM/DD/YYYY') : null;
            let range = [];
            if (startDate !== null && endDate !== null) {
                range = getDates(moment(startDate), moment(endDate));
            } else if (startDate !== null && endDate === null) {
                range = [startDate];
            } else if (startDate === null && endDate !== null) {
                range = [endDate];
            }
            activityDates = [...activityDates, ...range];
        });
        let uniqueDates = [...new Set(activityDates)];
        uniqueDates = uniqueDates.sort((a, b) => moment(a) - moment(b));
        let allData = [];
        let data = [];

        uniqueDates.forEach((el) => {
            let list = [...result];
            allData = list.filter((x) => {
                if (x.actualData.startDateTime !== null) {
                    //&& x.actualData.endDateTime !== null
                    if (
                        moment(el).format('MM/DD/YYY') ==
                        moment(x.actualData.startDateTime).format('MM/DD/YYY')
                    )
                        //&& moment(el).format('MM/DD/YYY') <= moment(x.actualData.endDateTime).format('MM/DD/YYY')
                        return x;
                } else if (
                    x.actualData.startDateTime === null &&
                    x.actualData.endDateTime !== null
                ) {
                    if (
                        moment(el).format('MM/DD/YYY') ==
                        moment(x.actualData.endDateTime).format('MM/DD/YYY')
                    )
                        return x;
                }
            });

            allData.forEach((row) => {
                let tagName = [];
                row.actualData.activityTags &&
                    row.actualData.activityTags !== null &&
                    row.actualData.activityTags.map((tag) => {
                        tagName.push(tag.tagName);
                    });
                data.push({
                    StartDate: Helper.FormatDate(row.actualData.startDateTime),
                    StartDatetime:
                        moment(row.actualData.startDateTime).format(
                            'hh:mm:ss'
                        ) === '12:00:00'
                            ? ''
                            : Helper.FormatTime(row.actualData.startDateTime),
                    // endDate: Helper.FormatDate(row.actualData.endDateTime),
                    EndDatetime:
                        moment(row.actualData.endDateTime).format(
                            'hh:mm:ss'
                        ) === '12:00:00'
                            ? ''
                            : Helper.FormatTime(row.actualData.endDateTime),
                    Activityname: row.actualData.activityName,
                    Location: row.actualData.location,
                    attire: row.actualData.attire,
                    notes: row.actualData.notes,
                    tags: tagName.join(','),
                });
                if (
                    row.actualData.subActivities &&
                    row.actualData.subActivities.length > 0
                ) {
                    row.actualData.subActivities.map((value) => {
                        data.push({
                            StartDate: '',
                            StartDatetime:
                                moment(value.startDateTime).format(
                                    'hh:mm:ss'
                                ) === '12:00:00'
                                    ? ''
                                    : Helper.FormatTime(value.startDateTime),
                            // endDate: Helper.FormatDate(value.endDateTime),
                            EndDatetime:
                                moment(value.endDateTime).format('hh:mm:ss') ===
                                    '12:00:00'
                                    ? ''
                                    : Helper.FormatTime(value.endDateTime),
                            Activityname: value.subActivityName,
                            Location: '',
                            attire: '',
                            notes: value.notes,
                            tags: '',
                        });
                    });
                }
            });
        });
        const header = {
            StartDate: 'StartDate',
            StartDatetime: 'StartTime',
            // endDate: 'EndDate',
            EndDatetime: 'EndDatetime',
            Activityname: 'ActivityName',
            Location: 'Location',
            attire: 'Attire',
            notes: 'Notes',
            tags: 'tags',
        };

        data.unshift(header);
        Helper.downloadReport(
            data,
            userName ? userName : ''
        );
    };
    const callUserActivityExport = async () => {
        let selectedParticipant = overallParticipants
            .get()
            .filter((i) => i.selected);

        if (selectedParticipant.length > 0) {
            setUserActivityExcelLoader(true);
            let playerIds = [];
            selectedParticipant &&
                selectedParticipant.length > 0 &&
                selectedParticipant.map((key) => {
                    playerIds.push(key.userID);
                });
            let RETURN_URL = AzureConstant.LOCAL_APP;
            if (window.location.href.includes(AzureConstant.DEV_APP)) {
                RETURN_URL = 'https://' + AzureConstant.DEV_APP;
            }
            if (window.location.href.includes(AzureConstant.QA_APP)) {
                RETURN_URL = 'https://' + AzureConstant.QA_APP;
            }
            if (window.location.href.includes(AzureConstant.CT_APP)) {
                RETURN_URL = 'https://' + AzureConstant.CT_APP;
            }
            if (window.location.href.includes(AzureConstant.PROD_APP)) {
                RETURN_URL = 'https://' + AzureConstant.PROD_APP;
            }
            let MAIN_URL = window.location.href.includes(AzureConstant.LOCAL_APP) ? RETURN_URL : RETURN_URL + '/'
            fetch(
                MAIN_URL +
                APIURLConstants.DOWNLOAD_INDIVIDUAL_SCHEDULE_EXPORT(
                    eventData.attach(Downgraded).get().eventID
                ),
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(playerIds),
                }
            )
                .then((res) => { return res.json() })
                .then((res) => {
                    const data = res;
                    if (data && data.length > 0) {
                        data.map(async (item, i) => {
                            let actData = []
                            if (item.activities.length > 0) {
                                item.activities.map((act) => {
                                    if (act.userType === ScheduleUserType[0] && act.isRowPublished === true) {
                                        actData.push({ actualData: act })
                                    }
                                })
                            }
                            setUserActivityExcelLoader(false);

                            for (var x = 0, ln = data.length; x < ln; x++) {
                                if (x === i) {
                                    setTimeout(function () {
                                        generateUserActivityExcelReport(
                                            actData,
                                            item.participant.replace(' ', '').substring(0, 30)
                                        );
                                    }, x * 500, x);
                                }
                            }
                            overallParticipants.set(
                                overallParticipants.get().map((i) => {
                                    i.selected = false;
                                    return i;
                                })
                            );
                        })
                    }
                })
                .catch((err) => {
                    console.log(err.message);
                });
        } else {
            setUserActivityExcelLoader(false);
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select at least one Participant.',
            });
        }
    };

    const callExport = () => {
        const selected = activityList
            .get()
            .filter((user) => user.selected === true);
        const allSelected = allActivityListData
            .get()
            .filter((user) => user.selected === false);
        if (selected.length === 0) {
            generateExcelReport(allSelected);
        } else {
            generateExcelReport(selected);
        }
    };
    const generateExcelReport = (result) => {
        let selectedIds = [];
        let IDs = null;
        if (result.length > 0) {
            result.map((item) => {
                selectedIds.push(item.actualData.activityID);
            });
            IDs = selectedIds.join(',');
        }

        ApiHelper.post(APIURLConstants.SCHEDULE_EXPORT, {
            EventID: eventData.get().eventID,
            ModuleID: 10,
            IDs: IDs
        }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            // console.log('finalObject', finalObject);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(
                        finalObject,
                        `Participant_Schedule-Report`
                    );
                }
            }
        });
    };
    const updateMassScheduleExcelReport = (result) => {
        let selectedIds = [];
        let IDs = null;
        if (result.length > 0) {
            result.map((item) => {
                selectedIds.push(item.actualData.activityID);
            });
            IDs = selectedIds.join(',');
        }

        ApiHelper.post(
            APIURLConstants.GET_MASS_SCHEDULE_EXCEL_EXPORT, {
            EventID: eventData.get().eventID,
            ModuleID: 10,
            IDs: IDs
        }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            // console.log('finalObject', finalObject);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(
                        finalObject,
                        `Mass-Update-Schedule-Report`
                    );
                }
            }
        });
    };
    const handleAddToPdfListArray = () => { };
    const sendIndividualScheduleEmail = () => {
        // setBackDrop(true);
        let selectedParticipant = overallParticipants
            .get()
            .filter((i) => i.selected)
            .map((x) => x.userID);
        if (selectedParticipant.length > 0) {
            setBackDrop(false);
            let message = 'Do you want to send schedule to participant?';
            sendEmailConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        } else {
            setBackDrop(false);
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select at least one participant.',
            });
        }
    };
    const sendIndividualScheduleEmailConfirm = () => {
        const userInfo = Helper.getStorage('userInfo');
        // console.log("userInfo",userInfo);
        // setBackDrop(true);
        setIndividualScheudleEmailLoader(true)
        let selectedParticipant = overallParticipants
            .get()
            .filter((i) => i.selected && i.isPublished && i.isSchedulePublished)
            .map((x) => x.userID);
        let allParticipants = overallParticipants.get();
        if (selectedParticipant.length > 0) {
            sendEmailConfirmation.set({
                open: false,
                title: '',
                OkButtonText: 'Ok',
                message: '',
            });
            setIndividualScheudleEmailLoader(true)
            ApiHelper.post(
                APIURLConstants.SEND_INDIVIDUAL_SCHEDULE(
                    eventData.attach(Downgraded).get().eventID,
                    ScheduleUserType[0],
                    userInfo.userID
                ),
                selectedParticipant
            )
                .then((res) => {
                    setBackDrop(false);
                    if (res.data) {
                        setSnackBarProps({
                            snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Email sent successfully.',
                        });
                        setIndividualScheudleEmailLoader(false)
                        setSelectAllFlag(true);
                    } else {
                        setIndividualScheudleEmailLoader(false)
                        setSnackBarProps({
                            snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please try after some time.',
                        });
                    }
                    overallParticipants.set(
                        allParticipants.map((i) => {
                            i.selected = false;
                            return i;
                        })
                    );
                })
                .catch((err) => {
                    setBackDrop(false);
                    setSelectAllFlag(false);
                    setIndividualScheudleEmailLoader(false)
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Please try after some time.',
                    });
                    overallParticipants.set(
                        allParticipants.map((i) => {
                            i.selected = false;
                            return i;
                        })
                    );
                    console.log(err);
                });
        } else {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message:
                    'Event or schedule is unpublished for this Participant',
            });
            setIndividualScheudleEmailLoader(false)
            sendEmailConfirmation.set({
                open: false,
                title: '',
                OkButtonText: 'Ok',
                message: '',
            });
            setBackDrop(false);
            overallParticipants.set(
                allParticipants.map((i) => {
                    i.selected = false;
                    return i;
                })
            );
        }
    };
    // const onCheckSelect = async (item) => {
    //     console.log("item",item);
    //     const eventInfo = Helper.getStorage('eventInfo');
    //     let result = await ScheduleDataService.getActivityList(
    //         eventInfo.eventID,
    //         item.userID
    //     );
    //     let scheduleData = [];
    //     if(result.data && result.data.length > 0){
    //         result.data.map((item) => {
    //             if (item.userType !== ScheduleUserType[1]) {
    //                 scheduleData.push({ actualData: item });
    //             }
    //         });
    //     }
    //     let oldPdfActivityData = pdfActivityData.concat(scheduleData);

    //     setPdfActivityData(oldPdfActivityData)
    //     console.log("scheduleData",scheduleData,pdfActivityData,oldPdfActivityData);
    // }
    const handleSelectedExportToPDF = () => {
        let selectedParticipant = overallParticipants
            .get()
            .filter((i) => i.selected);

        if (selectedParticipant.length > 0) {
            let playerIds = [];
            selectedParticipant &&
                selectedParticipant.length > 0 &&
                selectedParticipant.map((key) => {
                    playerIds.push(key.userID);
                });
            setUserActivityPDFLoader(true);
            let RETURN_URL = AzureConstant.LOCAL_APP;
            if (window.location.href.includes(AzureConstant.DEV_APP)) {
                RETURN_URL = 'https://' + AzureConstant.DEV_APP;
            }
            if (window.location.href.includes(AzureConstant.QA_APP)) {
                RETURN_URL = 'https://' + AzureConstant.QA_APP;
            }
            if (window.location.href.includes(AzureConstant.CT_APP)) {
                RETURN_URL = 'https://' + AzureConstant.CT_APP;
            }
            if (window.location.href.includes(AzureConstant.PROD_APP)) {
                RETURN_URL = 'https://' + AzureConstant.PROD_APP;
            }
            let MAIN_URL = window.location.href.includes(AzureConstant.LOCAL_APP) ? RETURN_URL : RETURN_URL + '/'
            fetch(
                MAIN_URL +
                APIURLConstants.DOWNLOAD_INDIVIDUAL_BULK_SCHEDULE(
                    eventData.attach(Downgraded).get().eventID,
                    ScheduleUserType[0],
                    selectUnPublished
                ),
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': 'Bearer ' + Helper.getStorage('accessToken'),
                    },
                    body: JSON.stringify(playerIds),
                }
            )
                .then((res) => res.blob())
                .then((blob) => {
                    saveAs(blob, 'ParticipantSchedule.zip');
                    setUserActivityPDFLoader(false);
                }) // saveAs is a function from the file-saver package.
                .catch((err) => {
                    console.log(err.message);
                });

        } else {
            setUserActivityPDFLoader(false);
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select at least one Participant.',
            });
        }
    };

    const resetGridFilters = () => {
        setSearch('');
        setpublishlistvalue('All');
        setGridFilters({
            ...gridFilters,
            search: '',
            date: [],
            filterByPublishUnPublish: ''
        });
    }

    // const exportToPDF = async () => {
    //     const mainContainerList =
    //         document.querySelectorAll("[id^='divToPrint']");
    //     for (let x = 0; x < mainContainerList.length; x++) {
    //         //let arrcontentId = mainContainerList[x].id.split('_');
    //         //let gameId = arrcontentId && arrcontentId.length > 0 ? arrcontentId[1] : '';
    //         let printableArea = mainContainerList[x];
    //         printableArea.style.display = 'block';
    //         var pdf = new jsPDF('l', 'pt', 'letter', false);

    //         pdf.internal.scaleFactor = 2.25;
    //         // get all elements with page-break classes to add page break
    //         var printableIds = printableArea.querySelectorAll('.page-break');

    //         for (let i = 0; i < printableIds.length; i++) {
    //             const content = printableIds[i];
    //             await html2canvas(content, {
    //                 useCORS: true,
    //                 allowTaint: true,
    //             }).then((canvas) => {
    //                 getCanvasPdfPages(pdf, canvas);
    //             });
    //             if (i < printableIds.length - 1) pdf.addPage();
    //         }

    //         printableArea.style.display = 'none';
    //         //setOpenBackDrop(false);

    //         let fileName = mainContainerList[x].id.slice(11) + '.pdf';

    //         // let gameData = gameList.find(g => g.gameId === gameId);
    //         // if (gameData) {
    //         //     fileName = 'PlayOffDeepDive_' + gameData.awayTeamAbr + '@' + gameData.homeTeamAbr + '-' + Helper.FormatDate(gameData.gameDate) + '.pdf'
    //         // }
    //         pdf.save(fileName);
    //     }
    // };

    // const exportToPDFNew = () => {
    //     const mainContainerList = document.querySelectorAll("[id^='divToPrint']");
    //     for (let x = 0; x < mainContainerList.length; x++) {
    //         let mainDiv = mainContainerList[x];
    //         mainDiv.style.display = 'none';
    //         //let fileName = mainContainerList[x].id.slice(11) + '.pdf';

    //     }

    // }

    // const getCanvasPdfPages = (pdf, canvas) => {
    //     var contentWidth = canvas.width;
    //     var contentHeight = canvas.height;

    //     //a4 paper size [595.28, 841.89] in pts. convert it into px by dividing (72 / 96)
    //     var paperWidth = 750; /// (72 / 96); 595.28
    //     var paperHeight = 590; /// (72 / 96); 841.89
    //     //One page pdf shows the canvas height generated by html pages.
    //     var pageHeight = (contentWidth / paperWidth) * paperHeight;
    //     //html page height without pdf generation
    //     var leftHeight = contentHeight;
    //     //Page offset
    //     var position = 0; //default value 0 -added 10 for top margin
    //     //a4 paper size [595.28, 841.89], html page generated canvas in pdf picture width
    //     var imgWidth = paperWidth - 40;
    //     var imgHeight = (paperWidth / contentWidth) * contentHeight;
    //     var pageData = canvas.toDataURL('image/png', 1.0);
    //     //There are two heights to distinguish, one is the actual height of the html page, and the page height of the generated pdf (841.89)
    //     //When the content does not exceed the range of pdf page display, there is no need to paginate
    //     if (leftHeight < pageHeight) {
    //         pdf.addImage(pageData, 'JPEG', 40, 40, imgWidth, imgHeight);
    //     } else {
    //         while (leftHeight > 0) {
    //             pdf.addImage(
    //                 pageData,
    //                 'JPEG',
    //                 40,
    //                 position,
    //                 imgWidth,
    //                 imgHeight
    //             );
    //             leftHeight -= pageHeight;
    //             position -= paperHeight;
    //             //Avoid adding blank pages
    //             if (leftHeight > 0) {
    //                 pdf.addPage();
    //             }
    //         }
    //     }
    // };

    // function getDates(startDate, endDate) {
    //     const dates = [];
    //     let currentDate = startDate;
    //     const addDays = function (days) {
    //         const date = new Date(this.valueOf());
    //         date.setDate(date.getDate() + days);
    //         return date;
    //     };
    //     while (currentDate <= endDate) {
    //         dates.push(moment(currentDate).format('MM/DD/YYYY'));
    //         currentDate = addDays.call(currentDate, 1);
    //     }
    //     return dates;
    // }
    // const generateExcelReport = (result, userName) => {
    //     let activityDates = [];
    //     result.map((item) => {
    //         let startDate =
    //             item.actualData.startDateTime !== null
    //                 ? moment(item.actualData.startDateTime).format('MM/DD/YYYY')
    //                 : null;
    //         let endDate = null; // item.actualData.endDateTime !== null ? moment(item.actualData.endDateTime).format('MM/DD/YYYY') : null;
    //         let range = [];
    //         if (startDate !== null && endDate !== null) {
    //             range = getDates(moment(startDate), moment(endDate));
    //         } else if (startDate !== null && endDate === null) {
    //             range = [startDate];
    //         } else if (startDate === null && endDate !== null) {
    //             range = [endDate];
    //         }
    //         activityDates = [...activityDates, ...range];
    //     });
    //     let uniqueDates = [...new Set(activityDates)];
    //     uniqueDates = uniqueDates.sort((a, b) => moment(a) - moment(b));
    //     let allData = [];
    //     let data = [];

    //     uniqueDates.forEach((el) => {
    //         let list = [...result];
    //         allData = list.filter((x) => {
    //             if (x.actualData.startDateTime !== null) {
    //                 //&& x.actualData.endDateTime !== null
    //                 if (
    //                     moment(el).format('MM/DD/YYY') ==
    //                     moment(x.actualData.startDateTime).format('MM/DD/YYY')
    //                 )
    //                     //&& moment(el).format('MM/DD/YYY') <= moment(x.actualData.endDateTime).format('MM/DD/YYY')
    //                     return x;
    //             } else if (
    //                 x.actualData.startDateTime === null &&
    //                 x.actualData.endDateTime !== null
    //             ) {
    //                 if (
    //                     moment(el).format('MM/DD/YYY') ==
    //                     moment(x.actualData.endDateTime).format('MM/DD/YYY')
    //                 )
    //                     return x;
    //             }
    //             // else if (x.actualData.startDateTime !== null && x.actualData.endDateTime === null) {
    //             //     if (moment(el).format('MM/DD/YYY') == moment(x.actualData.startDateTime).format('MM/DD/YYY'))
    //             //         return x;
    //             // }
    //         });

    //         allData.forEach((row) => {
    //             data.push({
    //                 StartDate: Helper.FormatDate(row.actualData.startDateTime),
    //                 StartDatetime: Helper.FormatTime(
    //                     row.actualData.startDateTime
    //                 ),
    //                 EndDatetime: Helper.FormatTime(row.actualData.endDateTime),
    //                 Activityname: row.actualData.activityName,
    //                 Location: row.actualData.location,
    //                 attire: row.actualData.attire,
    //                 notes: row.actualData.notes,
    //             });
    //         });
    //     });
    //     const header = {
    //         StartDate: 'Date',
    //         StartDatetime: 'Start',
    //         EndDatetime: 'End',
    //         Activityname: 'ActivityName',
    //         Location: 'Location',
    //         attire: 'Attire',
    //         notes: 'Notes',
    //     };

    //     data.unshift(header);
    //     Helper.downloadReport(
    //         data,
    //         `${userName ? `${userName}_` : ''}Schedule-Report`
    //     );
    // };

    const handleConfirmation = () => {
        if (selectedIds.attach(Downgraded).get().length === 0) {
            let deleteActivity = [];
            activityList.get().map((activity) => {
                if (activity.selected === true) {
                    deleteActivity.push(activity.actualData.activityID);
                }
            });

            ApiHelper.post(APIURLConstants.DELETE_ACTIVITY_LIST, {
                ids: deleteActivity,
                modifiedBy: userInfo.attach(Downgraded).get().userID,
                eventID: eventData.attach(Downgraded).get().eventID,
            })
                .then((res) => {
                    if (res.data) {
                        setSnackBarProps({
                            snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Activity List deleted successfully',
                        });
                        fetchActivities(userId.get());
                    }
                })
                .catch((error) => {
                    console.log('error : ', error);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                        setSnackBarProps({
                            snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: message,
                        });
                    } else {
                        message = 'Activity List deleted Successfully';
                        setSnackBarProps({
                            snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: message,
                        });
                    }
                    fetchActivities(userId.get());
                });
        } else {
            let Ids = selectedIds.attach(Downgraded).get();
            let payLoad = {
                userID: selectedUser.get(),
                modifiedBy: userInfo.attach(Downgraded).get().userID,
                activityID: Ids,
            };
            ScheduleDataService.deleteUserActivities(payLoad)
                .then((res) => {
                    if (res > 0) {
                        setSnackBarProps({
                            snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'User activity deleted successfully',
                        });
                        fetchActivities(userId.get());
                        selectedIds.set([]);
                    }
                })
                .catch((error) => {
                    console.log('error : ', error);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                        setSnackBarProps({
                            snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: message,
                        });
                    } else {
                        message = 'User activity deleted successfully';
                        setSnackBarProps({
                            snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: message,
                        });
                    }
                    fetchActivities(userId.get());
                });
        }
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const handleActivitiesDelete = (userId, activtyIds) => {
        selectedUser.set(userId);
        selectedIds.set(activtyIds);
        if (activtyIds.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Activity first',
            });
        } else {
            let message =
                activtyIds.length == activityList.get().length
                    ? 'Do you want to delete all Activity Lists ?'
                    : 'Do you want to delete selected Activity List ?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const openActivityListDialog = (userId) => {
        openActivityDialog.set(true);
        selectedUser.set(userId);
    };
    const assignActivitiesToParticipant = (ids) => {
        if (ids.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select activities first',
            });
        } else {
            let payload = {
                userID: selectedUser.get(),
                createdBy: userInfo.attach(Downgraded).get().userID,
                ActivityID: ids,
            };

            ScheduleDataService.assignActivityToParticipants(payload)
                .then((res) => {
                    if (res) {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'success',
                            message: 'Activity added successfully.',
                        });
                        fetchActivities(userId.get());
                        openActivityDialog.set(false);
                    } else {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Something went wrong.',
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'Something went wrong.',
                    });
                });
        }
    };

    const handleCloseActivityListDialog = () => {
        openActivityDialog.set(false);
    };

    const handleMassUpdateImportActivity = (attachmentDocument) => {
        if (attachmentDocument && attachmentDocument.target.files[0]) {
            let uploadFile = attachmentDocument.target.files[0];
            if (excelFileType.includes(uploadFile.type)) {
                let form = new FormData();
                //setIsLoading(true);Activity import failed.
                form.append('attachedFile', uploadFile);
                form.append(
                    'eventId',
                    eventData.attach(Downgraded).get().eventID
                );
                form.append('userId', userInfo.attach(Downgraded).get().userID);
                setUploadActivityLoader(true)
                ScheduleDataService.importMassActivity(
                    form,
                    ScheduleUserType[0]
                )
                    .then((response) => {
                        let result = response;
                        setUploadActivityLoader(false)
                        if (result.status > 0) {
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: result.message,
                            });
                            fetchActivities(userId.get());
                        } else {
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'error',
                                message: result.message,
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setUploadActivityLoader(false)
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Activity import failed.',
                        });
                    });
            } else {
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message:
                        'Invalid file format, Please upload valid excel file.',
                });
            }
        } else {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Please select a file to upload.',
            });
        }
        attachmentDocument.target.value = null;
    };
    const handleImportActivity = (attachmentDocument) => {
        if (attachmentDocument && attachmentDocument.target.files[0]) {
            let uploadFile = attachmentDocument.target.files[0];
            if (excelFileType.includes(uploadFile.type)) {
                let form = new FormData();
                //setIsLoading(true);Activity import failed.
                form.append('attachedFile', uploadFile);
                form.append(
                    'eventId',
                    eventData.attach(Downgraded).get().eventID
                );
                form.append('userId', userInfo.attach(Downgraded).get().userID);
                ScheduleDataService.importActivity(form, ScheduleUserType[0])
                    .then((response) => {
                        let result = response;
                        if (result.status > 0) {
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: result.message,
                            });
                            fetchActivities(userId.get());
                        } else {
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'error',
                                message: result.message,
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Activity import failed.',
                        });
                    });
            } else {
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message:
                        'Invalid file format, Please upload valid excel file.',
                });
            }
        } else {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Please select a file to upload.',
            });
        }
        attachmentDocument.target.value = null;
    };
    const downloadTemplate = () => {
        ScheduleDataService.downloadImportTemplate()
            .then((res) => {
                let fileName = 'Upload_Activity_Schedule_Template.xlsx';
                const blob = new Blob([res], {
                    type: 'application/octet-stream',
                });
                saveAs(blob, fileName);
            })
            .catch((err) => {
                console.log(err);
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Something went wrong, please contact admin.',
                });
            });
    };

    const selectedReport = (value) => {
        // console.log('value', value);
        selectedScheduleReport.set(value);
    };

    //useMemo is used to avoid rerender in case of props.setOpenBackDrop(false) from pdfDownload
    const pdfDownload = useMemo(() => {
        return (
            <PDFDownload
                selectedScheduleReport={selectedScheduleReport
                    .attach(Downgraded)
                    .get()}
                setSelectedScheduleReport={selectedReport}
                open={setBackDrop}
            />
        );
    }, [selectedScheduleReport.get()]);
    // const handlePublish = () =>
    // {
    // const selected = activityList
    //     .get()
    //     .filter((user) => user.selected === true);
    // if (selected.length === 0)
    // {
    //     setSnackBarProps({
    //         snackBarProps,
    //         openSnack: true,
    //         variant: 'error',
    //         message: 'Please select atleast one Activity ',
    //     });
    // } else
    // {
    //     let activityIds = []
    //     activityList.get().map((activity) =>
    //     {
    //         if (activity.selected === true)
    //         {
    //             activityIds.push(activity.actualData.activityID);
    //             console.log(activity.actualData.participants.length);
    //         }
    //     });

    //     let obj = {
    //         eventID: eventData.get().eventID,
    //         isPublished: true,
    //         modifiedBy: userInfo.get().userID
    //     }
    //     ScheduleDataService.publishActivity(obj).then(res =>
    //     {
    //         console.log(res);
    //         if (res)
    //         {
    //             setSnackBarProps({
    //                 openSnack: true,
    //                 variant: 'success',
    //                 message: 'Activity list Published successfully',
    //             });
    //             fetchActivities(userId.get());
    //         }
    //     }).catch((err) =>
    //     {
    //         console.log(err);
    //         setSnackBarProps({
    //             openSnack: true,
    //             variant: 'error',
    //             message: 'Something went wrong.',
    //         });
    //         fetchActivities(userId.get());
    //     })
    //     // }
    // }
    // const handleUnPublish = () =>
    // {
    //     let obj = {
    //         eventID: eventData.get().eventID,
    //         isPublished: false,
    //         modifiedBy: userInfo.get().userID
    //     }
    //     ScheduleDataService.publishActivity(obj).then(res =>
    //     {
    //         console.log(res);
    //         if (res)
    //         {
    //             setSnackBarProps({
    //                 openSnack: true,
    //                 variant: 'success',
    //                 message: 'Activity list UnPublished successfully',
    //             });
    //             fetchActivities(userId.get());
    //         }
    //     }).catch((err) =>
    //     {
    //         console.log(err);
    //         setSnackBarProps({
    //             openSnack: true,
    //             variant: 'error',
    //             message: 'Something went wrong.',
    //         });
    //     })

    // }
    // const getSelectedUsersID = () => {

    // }
    const savePublishedAppNotificationData = (obj) => {
        ApiHelper.post(
            APIURLConstants.POST_PUBLISH_ACTIVITY_SAVE_APP_NOTIFICATION,
            obj
        )
            .then((response) => {
                console.log("response",response);
            }).catch((error) =>{
                console.log("error",error);
            });
    }
    const saveAppNotificationData = () => {
        ApiHelper.get(
            APIURLConstants.GET_ACTIVITY_PARTICIPANT_LIST_BY_EVENT_ID(
                eventData.get().eventID,
                1
            )
        )
            .then((res) => {
                if (res.data) {
                    const sperated = res.data.toString().split(',');
                    const uniqueArrays = [...new Set(sperated)];
                    // console.log(uniqueArrays);
                    let filteredIds = overallParticipants
                        .attach(Downgraded)
                        .get()
                        .filter((elem) => {
                            return uniqueArrays.some((ele) => {
                                return (
                                    elem.isPublished &&
                                    elem.isSchedulePublished &&
                                    ele === elem.userID
                                );
                            });
                        })
                        .map((x) => {
                            return x.userID;
                        });
                    // console.log(filteredIds);
                    const AppNotificationData = {
                        userIDs: filteredIds.toString(),
                        appNotificationTypeID: 3,
                        eventID: eventData.get().eventID,
                        moduleID: 10,
                        recordRefID: 0,
                        requestStatus: 2,
                        status: 0,
                        createdBy: userInfo.attach(Downgraded).get().userID,
                    };
                    ApiHelper.post(
                        APIURLConstants.SAVE_APP_NOTIFICATION,
                        AppNotificationData
                    )
                        .then((response) => {
                            // console.log('res1', response);
                            res.data.map((val) => {
                                ApiHelper.get(
                                    APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                                        val.userID,
                                        Number(eventData.get().eventID),
                                        eventData.get().eventName,
                                        'Schedule',
                                        'Published'
                                    )
                                ).then((res) => {
                                    console.log(res);
                                });
                            });
                        })
                        .catch((err) => {
                            console.log('err', err);
                        });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const saveAppRowNotificationData = (item, notificationType) => {
        let filterdUserId = [];
        item &&
            item.length > 0 &&
            item.map((activityID) => {
                ScheduleDataService.getActivityParticipants(activityID)
                    .then((participants) => {
                        let ids = participants.map((x) => x.userID);
                        let allParticipants = overallParticipants
                            .attach(Downgraded)
                            .get();
                        let userList = allParticipants.filter((x) =>
                            ids.includes(x.userID)
                        );
                        let userIDs = userList.map((x) => x.userID);
                        if (userIDs.length > 0) {
                            userIDs.forEach((item) => {
                                filterdUserId.push(item);
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Something went wrong.',
                        });
                    });
            });
        setTimeout(() => {
            let uniqueIDs = filterdUserId.filter((val, id, array) => {
                return array.indexOf(val) == id;
            });
            // console.log(uniqueIDs);
            let filteredIds = overallParticipants
                .attach(Downgraded)
                .get()
                .filter((elem) => {
                    return uniqueIDs.some((ele) => {
                        return (
                            elem.isPublished &&
                            elem.isSchedulePublished &&
                            ele === elem.userID
                        );
                    });
                })
                .map((x) => {
                    return x.userID;
                });
            // console.log(filteredIds);
            const AppNotificationData = {
                userIDs: filteredIds.join(','),
                appNotificationTypeID: notificationType,
                eventID: eventData.get().eventID,
                moduleID: 10,
                recordRefID: 0,
                requestStatus: 2,
                status: 0,
                createdBy: userInfo.attach(Downgraded).get().userID,
            };
            ApiHelper.post(
                APIURLConstants.SAVE_APP_NOTIFICATION,
                AppNotificationData
            )
                .then((response) => {
                    // console.log('res1', response);
                    filteredIds.map((val) => {
                        ApiHelper.get(
                            APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                                val,
                                Number(eventData.get().eventID),
                                eventData.get().eventName,
                                'Schedule',
                                notificationType === 3
                                    ? 'Published'
                                    : 'UnPublished'
                            )
                        ).then((res1) => {
                            console.log(res1);
                        });
                    });
                })
                .catch((err) => {
                    console.log('err', err);
                });
        }, 1500);
    };
    const publishAll = () => {
        publishConfirmation.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: 'Are You Sure! You want to Publish All?',
        });
    };
    const handlePublishConfirmation = () => {
        let eventInfo = Helper.getStorage('eventInfo');
        let selectedActivity = [];
        activityList.get().map((activity) => {
            selectedActivity.push(activity.actualData.activityID);
        });
        let obj = {
            eventID: eventData.get().eventID,
            moduleID: 10,
            isPublished: true,
            modifiedBy: userInfo.get().userID,
            iDs: selectedActivity.join(','),
            userType: ScheduleUserType[0],
            eventName: eventData.get().eventName,
        };
        ScheduleDataService.publishActivity(obj)
            .then((res) => {
                if (res) {
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'success',
                        message: 'Activity list Published successfully',
                    });

                    eventInfo.isPublished = obj.isPublished;
                    Helper.setStorage('eventInfo', eventInfo);
                    eventData.set(eventInfo);
                  
                    fetchActivities(userId.get());
                    publishConfirmation.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                    });
                    savePublishedAppNotificationData(obj);
                }
            })
            .catch((err) => {
                console.log(err);
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Something went wrong.',
                });
                fetchActivities(userId.get());
            });
    };
    const unPublishAll = () => {
        unPublishConfirmation.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: 'Are You Sure! You want to UnPublish All?',
        });
    };
    const handleUnblishConfirmation = () => {
        // console.log('hello');
        let eventInfo = Helper.getStorage('eventInfo');
        let selectedActivity = [];
        activityList.get().map((activity) => {
            selectedActivity.push(activity.actualData.activityID);
        });
        let obj = {
            eventID: eventData.get().eventID,
            moduleID: 10,
            isPublished: false,
            modifiedBy: userInfo.get().userID,
            iDs: selectedActivity.join(','),
            userType: ScheduleUserType[0],
            eventName: eventData.get().eventName,
        };
        ScheduleDataService.publishActivity(obj)
            .then((res) => {
                if (res) {
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'success',
                        message: 'Activity list UnPublished successfully',
                    });

                    eventInfo.isPublished = obj.isPublished;
                    Helper.setStorage('eventInfo', eventInfo);
                    eventData.set(eventInfo);
                    // console.log(eventInfo.readonlyOrHide);
                    // eventInfo.readonlyOrHide === 0
                    //     ? saveAppNotificationData()
                    //     : '';
                    fetchActivities(userId.get());
                    unPublishConfirmation.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                    });
                    savePublishedAppNotificationData(obj)
                }
            })
            .catch((err) => {
                console.log(err);
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Something went wrong.',
                });
                fetchActivities(userId.get());
            });
    };

    const handlepublishlistdata = (value) => {
        const selectedOption = publishlistdata.find(
            (option) => option.value == value
        );
        setpublishlistvalue(selectedOption.value);
        setGridFilters({
            ...gridFilters,
            filterByPublishUnPublish: selectedOption.value !== 'All' ? selectedOption.value : ''
        });
        // if (selectedOption.value === 'All') {
        //     activityList.set(allpublishData);
        // } else if (selectedOption.value === 'UnPublished') {
        //     activityList.set(unpublishData);
        // } else if (selectedOption.value === 'Published') {
        //     activityList.set(publishData);
        // }
    };

    const publishSelected = () => {
        const selected = activityList
            .attach(Downgraded)
            .get()
            .filter((row) => row.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select acitivity first',
            });
        } else {
            let messages = 'Do you want to publish all selected?';

            publishSelectedConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: messages,
            });
        }
    };
    const handlePublishSelectedconfirmation = () => {
        let selectedActivity = [];
        activityList.get().map((activity) => {
            if (activity.selected === true) {
                selectedActivity.push(activity.actualData.activityID);
            }
        });
        if (selectedActivity.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Activity first',
            });
            return false;
        }
        let obj = {
            eventID: eventData.get().eventID,
            moduleID: 10,
            isPublished: true,
            modifiedBy: userInfo.get().userID,
            iDs: selectedActivity.join(','),
            userType: ScheduleUserType[0],
            eventName: eventData.get().eventName,
        };

        setPublishLoader(true)
        //setBackDrop(true);
        publishSelectedConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
        ScheduleDataService.publishActivity(obj)
            .then((res) => {
                //setBackDrop(false);
                if (res) {
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'success',
                        message: 'Activity list Published successfully',
                    });
                    // saveAppRowNotificationData(selectedActivity, 3);
                    fetchActivities(userId.get());
                    setSubmitPublishUnpublished(true);
                    setPublishLoader(false)
                    publishSelectedConfirmation.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                    });
                    savePublishedAppNotificationData(obj)
                }
            })
            .catch((err) => {
                //setBackDrop(false);
                console.log(err);
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Something went wrong.',
                });
                setPublishLoader(false)
                publishSelectedConfirmation.set({
                    open: false,
                    title: '',
                    OkButtonText: 'Ok',
                    message: '',
                });
                fetchActivities(userId.get());
            });
    };
    const unPublishSelected = () => {
        const selected = activityList
            .attach(Downgraded)
            .get()
            .filter((row) => row.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select acitivity first',
            });
        } else {
            let messages = 'Do you want to UnPublish all selected?';

            unPublishSelectedConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: messages,
            });
        }
    };
    const handleUnPublishSelectedConfirmation = () => {
        let selectedActivity = [];
        activityList.get().map((activity) => {
            if (activity.selected === true) {
                selectedActivity.push(activity.actualData.activityID);
            }
        });
        if (selectedActivity.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Activity first',
            });
            return false;
        }
        setUnublishLoader(true)
        let obj = {
            eventID: eventData.get().eventID,
            moduleID: 10,
            isPublished: false,
            modifiedBy: userInfo.get().userID,
            iDs: selectedActivity.join(','),
            userType: ScheduleUserType[0],
            eventName: eventData.get().eventName,
        };
        unPublishSelectedConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
        //setBackDrop(true);
        ScheduleDataService.publishActivity(obj)
            .then((res) => {
                // setBackDrop(false);
                if (res) {
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'success',
                        message: 'Activity list UnPublished successfully',
                    });
                    fetchActivities(userId.get());
                    setSubmitPublishUnpublished(true);
                    setUnublishLoader(false)
                    unPublishSelectedConfirmation.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                    });
                    savePublishedAppNotificationData(obj)
                }
            })
            .catch((err) => {
                // setBackDrop(false);
                console.log(err);
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Something went wrong.',
                });
                setUnublishLoader(false)
                unPublishSelectedConfirmation.set({
                    open: false,
                    title: '',
                    OkButtonText: 'Ok',
                    message: '',
                });
                fetchActivities(userId.get());
            });
    };
    // const onToggleChange = () =>
    // {
    //     let eventInfo = Helper.getStorage('eventInfo');

    //     let obj = {
    //         eventID: eventData.get().eventID,
    //         isPublished: eventInfo.isPublished ? false : true,
    //         modifiedBy: userInfo.get().userID,
    //     };
    //     ScheduleDataService.publishActivity(obj, ScheduleUserType[0])
    //         .then((res) =>
    //         {
    //             if (res)
    //             {
    //                 setSnackBarProps({
    //                     openSnack: true,
    //                     variant: 'success',
    //                     message: obj.isPublished
    //                         ? 'Activity list Published successfully'
    //                         : 'Activity list UnPublished successfully',
    //                 });

    //                 eventInfo.isPublished = obj.isPublished;
    //                 Helper.setStorage('eventInfo', eventInfo);
    //                 eventData.set(eventInfo);
    //                 eventInfo.readonlyOrHide === 0 ? saveAppNotificationData() : "";
    //                 fetchActivities(userId.get());
    //             }
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //             setSnackBarProps({
    //                 openSnack: true,
    //                 variant: 'error',
    //                 message: 'Something went wrong.',
    //             });
    //             fetchActivities(userId.get());
    //         });
    // };
    const onStaffToggleChange = (e) => {
        setStaffToggleChecked(e.target.checked);
        if (e.target.checked) {
            fetchActivities(userInfo.attach(Downgraded).get().userID);
        } else {
            fetchActivities(userId.get());
        }
    };
    const onRowToggleChange = (item) => {
        let obj = {
            eventID: eventData.get().eventID,
            moduleID: 10,
            isPublished: item.actualData.isRowPublished ? false : true,
            modifiedBy: userInfo.get().userID,
            iDs: item.actualData.activityID.toString(),
            userTpe: ScheduleUserType[0],
            eventName: eventData.get().eventName,
        };
        ScheduleDataService.publishActivity(obj)
            .then((res) => {
                if (res) {
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'success',
                        message: obj.isPublished
                            ? 'Activity list Published successfully'
                            : 'Activity list UnPublished successfully',
                    });
                    fetchActivities(userId.get());
                    // obj.isPublished ? saveAppRowNotificationData(item, 3) : '';
                }
            })
            .catch((err) => {
                console.log(err);
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Something went wrong.',
                });
                fetchActivities(userId.get());
            });
    };

    const updateTemplate = () => {
        const selected = activityList
            .get()
            .filter((user) => user.selected === true);
        const allSelected = allActivityListData
            .get()
            .filter((user) => user.selected === false);
        if (selected.length === 0) {
            updateMassScheduleExcelReport(allSelected);
        } else {
            updateMassScheduleExcelReport(selected);
        }
    };
    const handleShowUnpublished = (event) => {
        // console.log('event', event.target.checked);
        setSelectUnPublished(event.target.checked);
    };
    // console.log("loading.get()",loading.get(), individualScheudleEmailLoader);
    return (
        <>
            {loading.get() ? (
                <Box
                    sx={
                        loading.get()
                            ? { paddingTop: '20%', paddingBottom: '20%' }
                            : ''
                    }
                    className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none' }}>
                    <DataList
                        participants={overallParticipants
                            .attach(Downgraded)
                            .get()}
                        showUsersList={
                            props.data &&
                            props.data.length > 0 &&
                            props.data[0].tab === 'userActivity'
                        }
                        isPage={true}
                        data={activityList.attach(Downgraded).get()}
                        showTabUser={showTabUser}
                        //dates={dates.attach(Downgraded).get()}
                        title={''}
                        showTemplateDownload={false}
                        handleAddSubActivity={handleAddSubActivity}
                        editSubActivityRow={editSubActivityRow}
                        handlePageChange={handlePageChange}
                        pagingInfo={pagingInfo.attach(Downgraded).get()}
                        deleteSubActivityRow={deleteSubActivityRow}
                        // showSubActivity={true}
                        downloadTemplate={downloadTemplate}
                        handleClick={redirectToCreate}
                        import={false}
                        showColorPicker={false}
                        setShowPrimaryColorPicker={setShowPrimaryColorPicker}
                        showPrimaryColorPicker={showPrimaryColorPicker}
                        setPrimaryColor={setPrimaryColor}
                        primaryColor={primaryColor}
                        showExport={true}
                        showPdfExport={
                            props.data &&
                                props.data.length > 0 &&
                                props.data[0].tab === 'userActivity'
                                ? true
                                : null
                        }
                        publish={eventData.get().isPublished}
                        editRow={editActivity}
                        handleAddParticipants={handleAddParticipants}
                        handleViewParticipants={handleViewParticipants}
                        showEdit={false}
                        activityInfo={activityInfo.attach(Downgraded).get()}
                        buttonTitle={'Add'}
                        deleteRows={deleteActivityList}
                        showSearch={true}
                        search={search}
                        publishlist={true}
                        publishlistdata={publishlistdata}
                        setpublishlistdata={setpublishlistdata}
                        handlepublishlistdata={handlepublishlistdata}
                        publishlistvalue={publishlistvalue}
                        showSelectedUser={
                            props.data &&
                            props.data.length > 0 &&
                            props.data[0].tab === 'userActivity'
                        }
                        importFileType={excelFileType}
                        callExport={callExport}
                        callUserActivityExport={callUserActivityExport}
                        showUserActivityExport={
                            props.data &&
                                props.data.length > 0 &&
                                props.data[0].tab === 'userActivity'
                                ? true
                                : false
                        }
                        callPdfExport={handleSelectedExportToPDF}
                        // onCheckSelect={onCheckSelect}
                        handleAddToPdfListArray={handleAddToPdfListArray}
                        sendIndividualScheduleEmail={
                            sendIndividualScheduleEmail
                        }
                        showPublish={
                            props.data &&
                                props.data.length > 0 &&
                                props.data[0].tab === 'userActivity'
                                ? false
                                : true
                        }
                        showUnPublish={
                            props.data &&
                                props.data.length > 0 &&
                                props.data[0].tab === 'userActivity'
                                ? false
                                : true
                        }
                        handleImportActivity={handleImportActivity}
                        handleActivitiesDelete={handleActivitiesDelete}
                        handleOnChange={handleOnChange}
                        activeUserId={handleActiveUserId}
                        openActivityListDialog={openActivityListDialog}
                        searchLabel={'Search'}
                        modPermission={modPermission}
                        selectAllFlag={selectAllFlag}
                        // handlePublish={handlePublish}
                        // handleUnPublish={handleUnPublish}
                        // onToggleChange={onToggleChange}
                        onStaffToggleChange={onStaffToggleChange}
                        showStafftoggleChange={
                            props.data &&
                                props.data.length > 0 &&
                                props.data[0].tab === 'userActivity'
                                ? false
                                : !(
                                    Helper.isAdminUser(userInfo) ||
                                    Helper.isEventAdmin(userInfo)
                                ) && Helper.isEventStaff(userInfo)
                                    ? true
                                    : false
                        }
                        staffToggleChecked={staffToggleChecked}
                        unPublishSelected={unPublishSelected}
                        publishSelected={publishSelected}
                        publishAll={publishAll}
                        unPublishAll={unPublishAll}
                        onRowToggleChange={onRowToggleChange}
                        showRowPublish={true}
                        fetchActivities={fetchActivities}
                        submitPublishUnpublished={submitPublishUnpublished}
                        setSubmitPublishUnpublished={setSubmitPublishUnpublished}
                        showForAdminOnly={showForAdminOnly}
                        userActivityPDFLoader={userActivityPDFLoader}
                        userActivityExcelLoader={userActivityExcelLoader}
                        updateTemplate={updateTemplate}
                        showUpdateTemplate={
                            props.data &&
                                props.data.length > 0 &&
                                props.data[0].tab === 'userActivity'
                                ? null
                                : true
                        }
                        handleShowUnpublished={handleShowUnpublished}
                        selectUnPublished={selectUnPublished}
                        showSlectUnpublished={
                            props.data &&
                                props.data.length > 0 &&
                                props.data[0].tab === 'userActivity'
                                ? true
                                : false
                        }
                        showUploadMassUpdateActivity={
                            props.data &&
                                props.data.length > 0 &&
                                props.data[0].tab === 'userActivity'
                                ? null
                                : true
                        }
                        handleMassUpdateImportActivity={
                            handleMassUpdateImportActivity
                        }
                        windowDataList={false}
                        virtuso={true}
                        gridFilters={gridFilters}
                        setGridFilters={setGridFilters}
                        filterDates={filterDates}
                        resetGridFilters={resetGridFilters}
                        adminSchedulePage
                        publishLoader={publishLoader}
                        unpublishLoader={unpublishLoader}
                        individualScheudleEmailLoader={individualScheudleEmailLoader}
                        uploadActivityLoader={uploadActivityLoader}
                    />
                </Paper>
            )}
            {openDialog.get() && (
                <AddAcctivity
                    open={openDialog.get()}
                    // title="CREATE NEW ACTIVITY"
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    handleClose={handleClose}
                    activityInfo={activityInfo.attach(Downgraded).get()}
                    getActivityList={fetchActivities}
                    selectedUser={selectedUser.get()}
                />
            )}
            {openSubActivityDialog.get() && (
                <AddSubAcctivity
                    open={openSubActivityDialog.get()}
                    // title="CREATE NEW SUB ACTIVITY"
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    handleClose={handleSubActivityClose}
                    activityInfo={subActivityInfo.attach(Downgraded).get()}
                    getActivityList={fetchActivities}
                    users={overallParticipants.attach(Downgraded).get()}
                    selectedUser={selectedUser.get()}
                />
            )}
            {openAddParticipantDialog.get() && (
                <UserListDialog
                    title={
                        !isView.get() ? 'ADD PARTICIPANTS' : 'VIEW PARTICIPANTS'
                    }
                    addParticipants={addParticipants}
                    open={openAddParticipantDialog.get()}
                    deleteParticipants={deleteParticipants}
                    handleClose={handleCloseAddParticipant}
                    users={filteredParticipants.attach(Downgraded).get()}
                    isView={isView.get()}
                    selectAllCheckBox={true}
                />
            )}
            {openActivityDialog.get() && (
                <ActivityListDialog
                    title={'Add Activities'}
                    assignActivitiesToParticipant={
                        assignActivitiesToParticipant
                    }
                    open={openActivityDialog.get()}
                    handleClose={handleCloseActivityListDialog}
                    activities={activityList.attach(Downgraded).get()}
                    selectedUser={selectedUser.get()}
                    getActivityList={fetchActivities}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={unPublishConfirmation.get().open}
                    message={unPublishConfirmation.get().message}
                    OkButtonText={unPublishConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleUnblishConfirmation(unPublishConfirmation)
                    }
                    onCancelClick={() => {
                        unPublishConfirmation.set({
                            ...unPublishConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={publishConfirmation.get().open}
                    message={publishConfirmation.get().message}
                    OkButtonText={publishConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handlePublishConfirmation(publishConfirmation)
                    }
                    onCancelClick={() => {
                        publishConfirmation.set({
                            ...publishConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={publishSelectedConfirmation.get().open}
                    message={publishSelectedConfirmation.get().message}
                    OkButtonText={
                        publishSelectedConfirmation.get().OkButtonText
                    }
                    handleCnfClick={() =>
                        handlePublishSelectedconfirmation(
                            publishSelectedConfirmation
                        )
                    }
                    onCancelClick={() => {
                        publishSelectedConfirmation.set({
                            ...publishSelectedConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={unPublishSelectedConfirmation.get().open}
                    message={unPublishSelectedConfirmation.get().message}
                    OkButtonText={
                        unPublishSelectedConfirmation.get().OkButtonText
                    }
                    handleCnfClick={() =>
                        handleUnPublishSelectedConfirmation(
                            unPublishSelectedConfirmation
                        )
                    }
                    onCancelClick={() => {
                        unPublishSelectedConfirmation.set({
                            ...unPublishSelectedConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={deleteSubActivityConfirmation.get().open}
                    message={deleteSubActivityConfirmation.get().message}
                    OkButtonText={
                        deleteSubActivityConfirmation.get().OkButtonText
                    }
                    handleCnfClick={() =>
                        handleSubActivityConfirmation(
                            deleteSubActivityConfirmation
                        )
                    }
                    onCancelClick={() => {
                        deleteSubActivityConfirmation.set({
                            ...deleteSubActivityConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={sendEmailConfirmation.get().open}
                    message={sendEmailConfirmation.get().message}
                    OkButtonText={sendEmailConfirmation.get().OkButtonText}
                    handleCnfClick={() => sendIndividualScheduleEmailConfirm()}
                    onCancelClick={() => {
                        sendEmailConfirmation.set({
                            ...sendEmailConfirmation.get(),
                            open: false,
                        });
                        setBackDrop(false);
                    }}></ConfirmationDialog>
            }
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 150,
                }}
                open={openBackdrop}
            //onClick={handleCloseBackDrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {/* {selectedScheduleReport.get() &&
                selectedScheduleReport.get().length > 0 &&
                selectedScheduleReport
                    .attach(Downgraded)
                    .get()
                    .map((i, index) => {
                        return (
                            <div
                                id={'divToPrint_' + i.participantName}
                                key={index}>
                                <PreviewReport exportToPDF data={i} />
                            </div>
                        );
                    })} */}

            {/* {selectedScheduleReport.get() &&
                selectedScheduleReport.get().length > 0 &&
                selectedScheduleReport
                    .attach(Downgraded)
                    .get()
                    .map((i, index) => {

                        let fileName;
                        const mainContainerList = document.querySelectorAll("[id^='divToPrint']");
                        for (let x = 0; x < mainContainerList.length; x++) {
                            let mainDiv = mainContainerList[x];
                            mainDiv.style.display = 'none';
                            fileName = mainContainerList[x].id.slice(11) + '.pdf';

                        }
                        return (
                            <PDFDownloadItem key={index}
                                id={'divToPrint_' + i.participantName}
                                fileName={fileName}
                                data={i}
                                exportToPDFNew={exportToPDFNew}
                            />
                        );
                    })} */}

            {pdfDownload}
        </>
    );
}
export default ActivityList;
